import React, { PureComponent } from 'react';

import { Svg, filterProps } from '@lglp/components';
import PropTypes from 'prop-types';

import { ICON } from 'translations';

import { translate } from '../mixins/composer';

export class LoaderComponent extends PureComponent {
  static displayName = 'LoaderComponent';

  static handledProps = ['title'];

  static propTypes = {
    title: PropTypes.string,
  };

  static defaultProps = {
    title: ICON.LOADER,
  };

  render() {
    const { title, t } = this.props;
    const rest = filterProps(LoaderComponent, this.props);

    return (
      <Svg title={t(title)} viewBox="0 0 165 165" {...rest}>
        <path
          d="M84.59 100.47a9.19 9.19 0 0 0 4.34-1c2.94-1.76 6.81-5 12.3-12.68L42.45 101.2zM53.85 66c2.81 1 12 4.24 17.09 7.7l.49.35 38.09-.6c.06-.09 1.46-2.56 2.29-4.15s1-3.24-.06-4.23-2.93-1.25-6.6-1.25h-51.1c-.41 0-1.44-.07-1.61.77a.89.89 0 0 0 .23.78 3 3 0 0 0 1.18.63zm76.58 9.54c-.85 0-56.61.88-57.47.91-.47 0-.6.12-.6.62 0 4.05-5.38 7.94-12.67 11.41-7.69 3.67-17.34 7.32-22.36 9.17-1.19.44-3.34 1.2-4 1.55s-.93.71-.76 1.21.74.77 2.64.26l2.87-.74c9.61-2.51 27.25-6.93 44.43-11.21 17.79-4.45 35.33-8.29 48.19-10.61 1-.18 1.84-.72 1.8-1.49s-.88-1.11-2.07-1.08z"
          fill="#003da5"
        />
      </Svg>
    );
  }
}

export default translate(LoaderComponent);
